import { OrderedDataFieldValue } from "../../dataFields/values/OrderedDataFieldValue";


export class Listing {
	public static readonly $type: string = "Listing";
	public readonly $type: string = Listing.$type;

	public id?: number;
	public name: string = "";
	public data: OrderedDataFieldValue[] = [];
}
